import { render, staticRenderFns } from "./banner_new.vue?vue&type=template&id=37f8ca35&scoped=true&"
import script from "./banner_new.vue?vue&type=script&lang=js&"
export * from "./banner_new.vue?vue&type=script&lang=js&"
import style0 from "./banner_new.vue?vue&type=style&index=0&id=37f8ca35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8ca35",
  null
  
)

export default component.exports